import React from 'react';
import './bubbles.css'; // Importing the CSS for styling

const Features = ({ bubblesData }) => {
  return (
    <div className="full-bubbles">
      <div className="features-container">
        <div className="features-grid">
          {bubblesData.map((bubble) => (
            <div key={bubble.id} className="feature-item-top main-animate">
              <div className="icon">
                <img src={bubble.icon} alt={bubble.title} loading="lazy" />
              </div>
              <h3 className="bubble-title">{bubble.title}</h3>
              <div className='title-line'/>
              <ul className="bullets">
                {bubble.content.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
